import { useMutation } from '@tanstack/react-query';
import { type PostalAddressResponse } from './interfaces';

export const usePostalAddress = () => {
  const { mutate, isPending } = useMutation<
    PostalAddressResponse,
    unknown,
    { cep: string }
  >({
    mutationFn: async ({ cep }) => {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      return response.json();
    },
  });

  return { getAddressByCep: mutate, isPending };
};
